module.exports = __webpack_public_path__ + "media/customizations/mywilloway/logo-481d72ef0fdf5adccc3359e6f6992ceb.png";